import { onSocket } from '@/api/socket';
import { onGameChanged, useApi } from '@/lib/hooks';
import { IconButton } from '@/ui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

/** Мигающий значок в шапке: в альянс пришли заявки, которые игрок может принять (глава, офицеры). */
export function AllianceApplicationsIndicator() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const pending = useApi<{ count: number }>('/alliance/applications/pending');
  const { reload } = pending;
  useEffect(() => {
    const offs = [
      onSocket('notification', (n) => {
        if (n.type === 'alliance_application') reload();
      }),
      onGameChanged(reload),
    ];
    // Заявку мог принять другой офицер — значок перечитывается раз в минуту
    const timer = window.setInterval(reload, 60_000);
    return () => {
      for (const off of offs) off();
      window.clearInterval(timer);
    };
  }, [reload]);
  const count = pending.data?.count ?? 0;
  if (count <= 0) return null;
  return (
    <IconButton
      icon="alliance"
      iconSize={22}
      badge={count}
      label={t('game:allianceApplications', { n: count })}
      className="!h-10 !w-10 mail-unread-blink"
      onClick={() => navigate('/game/alliance')}
    />
  );
}
